import React from 'react';
import './Projects.css';

const projects = [
  {
    name: 'MIDAS',
    subtitle: 'AI + Computer Vision Repair Assistant',
    bullets: [
      'Built an end-to-end AI system using computer vision and voice input to diagnose and guide users through device repairs in real time.',
      'Developed a computer vision pipeline using YOLO and OpenCV for component detection and fault identification.',
      'Integrated GPT for dynamic instruction generation and Whisper for speech input, enabling hands-free interaction.',
      'Designed backend services with FastAPI and stored structured outputs using PostgreSQL/Supabase.',
    ],
    tech: ['Python', 'FastAPI', 'OpenCV', 'YOLO', 'React', 'OpenAI APIs', 'Supabase'],
    link: { label: 'Devpost', href: 'https://devpost.com/software/midas-bz3mqg' },
  },
  {
    name: 'UWaterloo Math Webring',
    subtitle: 'Founder',
    bullets: [
      'Built the largest University of Waterloo math webring connecting 150+ student websites.',
      'Developed an embeddable JavaScript widget for cross-site navigation.',
      'Designed a GitHub-based submission system using pull requests.',
    ],
    tech: ['TypeScript', 'Next.js', 'GitHub APIs'],
    link: null,
  },
  {
    name: 'Market Sentiment Analyzer',
    subtitle: null,
    bullets: [
      'Built an NLP pipeline analyzing 100+ financial news headlines using sentiment classification.',
      'Integrated APIs to fetch real-time financial data and compute aggregate sentiment scores per ticker.',
      'Explored relationships between sentiment signals and short-term price movements.',
    ],
    tech: ['Python', 'NLP', 'REST APIs'],
    link: null,
  },
];

export default function Projects() {
  return (
    <section id="projects" className="projects">
      <div className="container">
        <p className="section-label">Projects</p>
        <h2 className="section-title">Things I've Built</h2>
        <div className="project-grid">
          {projects.map((p) => (
            <div key={p.name} className="project-card">
              <div className="project-card-top">
                <div>
                  <h3 className="project-name">{p.name}</h3>
                  {p.subtitle && <p className="project-subtitle">{p.subtitle}</p>}
                </div>
                {p.link && (
                  <a
                    href={p.link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    {p.link.label} ↗
                  </a>
                )}
              </div>
              <ul className="project-bullets">
                {p.bullets.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>
              <div className="project-tech">
                {p.tech.map((t) => (
                  <span key={t} className="tech-tag">{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
